import 'regenerator-runtime/runtime';
import 'core-js/stable';
// react-ADAL setup
import { MsalProvider } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { msalInstance } from './msalConfig';
// app setup
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slices';
import App from './App';
import * as localForage from 'localforage';
import { SHOULD_LOADS_REDIRECT } from 'shared/../constants/Globals';
// styles
import 'flatpickr/dist/themes/material_green.css';
import 'toastr/build/toastr.css';
import './styles/index.scss';
import './shared/css/index.scss'; // Shared styles - light mode
import './shared/css/custom/07-components/_index.scss'; // Shared components styles - light mode
import 'react-virtualized/styles.css';

// Create browser history to use in the Redux store
// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;

const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['modal', 'confirmDialog', 'items'],
        ignoredActions: ['modal/showModal', 'confirmDialog/showConfirmDialog'],
      },
    }),
});

const rootElement = document.getElementById('root');

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback(async (event) => {
  // Callback that is fired whenever a user logs into the application. Any logic
  // that we want to run on only login should be placed here.
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);

    try {
      await localForage.setItem(SHOULD_LOADS_REDIRECT, true);
    } catch (error) {
      console.error(error);
    }
  }
});

ReactDOM.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </Provider>,
  rootElement,
);
